module.exports = __webpack_public_path__ + "4bf71dd5e5d895ef0f5aafcbb4d29bb3.woff";